import { render, staticRenderFns } from "./eyeScene.vue?vue&type=template&id=ad42c74c&scoped=true&"
import script from "./eyeScene.vue?vue&type=script&lang=js&"
export * from "./eyeScene.vue?vue&type=script&lang=js&"
import style0 from "./eyeScene.vue?vue&type=style&index=0&id=ad42c74c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad42c74c",
  null
  
)

export default component.exports